import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { take } from 'rxjs/operators';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-sec002-card-IX',
    templateUrl: './sec002-card-IX.component.html'
})

export class Sec002CardIXComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listOptionsFxLaranja?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsFxCinza?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    @Output() mkCalc = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Faixa de Qualidade (FÍSICA)', false);
        if (this.isComercial || this.isBasica) {
            this.formulario = this.formBuilder.group({
                Faixa_laranja: [null, []],
                Faixa_cinza: [null, []],
            });
        } else {
            this.formulario = this.formBuilder.group({
                Faixa_laranja: [null, []],
                Faixa_cinza: [null, []],
            });
        }

    }

    public async ngOnInit(): Promise<void> {
        await this.getLists();
        // await this.getFilters();
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async getLists(): Promise<void> {
        await this.getListOption();
    }

    async getFilters(): Promise<void> {
        await Promise.all([this.createFilterFxLaranja(), this.createFilterFxCinza()]);
    }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }

    private async getListOption(): Promise<void> {
        if (this.isPreBasica) {
            await this.formularioService.getListDropDownList('sec002', 'faixa_laranja', 'PET').pipe(take(1)).toPromise().then((response: any) => {
                if (!!response?.data) {
                    this.listOptionsFxLaranja = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                }
            }).catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(error, error.message);
            });

            await this.formularioService.getListDropDownList('sec002', 'faixa_cinza', 'PET').pipe(take(1)).toPromise().then((response: any) => {
                if (!!response?.data) {
                    this.listOptionsFxCinza = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                }
            }).catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(error, error.message);
            });
        }
        else {
            await this.formularioService.getListDropDownList('qua007', 'ultima_carga').pipe(take(1)).toPromise().then((response: any) => {
                if (!!response?.data) {
                    this.listOptionsFxLaranja = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                    this.listOptionsFxCinza = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                    this.listOptionsOriginal = this.listOptionsFxLaranja;
                }
            }).catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(error, error.message);
            });
        }

    }

    async createFilterFxLaranja(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsFxLaranja = this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsFxLaranja = this.listOptionsOriginal;
            }
        } else {
            this.listOptionsFxLaranja = this.listOptionsOriginal;
        }

        // this.filteredOptions = this.formulario.get('Faixa_laranja').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listOptions, value))
        //     );
    }

    async createFilterFxCinza(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsFxCinza = this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsFxCinza = this.listOptionsOriginal;
            }
        } else {
            this.listOptionsFxCinza = this.listOptionsOriginal;
        }

        // this.filteredOptions = this.formulario.get('Faixa_cinza').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listOptions, value))
        //     );
    }
}
